import React from 'react';

export default () => (
    <a target="_blank" id="play-store-badge" rel="noopener noreferrer"  href='https://play.google.com/store/apps/details?id=com.grupoapok.laguia&utm_source=www.laguiavalentinaquintero.com&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
        <img alt='Disponible en Google Play' src='https://play.google.com/intl/en_us/badges/images/generic/es-419_badge_web_generic.png'/>
    </a>
);


// WEBPACK FOOTER //
// ./src/components/PlayStoreBadge.js